module.exports = __webpack_public_path__ + "static/media/AiDesignerImageBoxBackground.deea2874.png";